import React from 'react'
import { webSocket } from './socket'

export var mainResponse;


export const sendAdvancedSearch = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'advancedSearch': data }));
        mainResponse = resolve;
    });
    return promise;
}

export const advancedSearch = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendAdvancedSearch(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}

export const sendFindUniqueStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'findStation': data }));
        mainResponse = resolve;
    });
    return promise;
}

export const findUniqueStation = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendFindUniqueStation(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}


export const sendGetServerType = (data) => {
    const promise = new Promise(function(resolve, reject) {
        webSocket.send(JSON.stringify({ 'getServerType': {} }));
        mainResponse = resolve;
    });
    return promise;
}

export const getServerType = (data) => {
    const promise = new Promise(function(resolve, reject) {
        sendGetServerType(data).then(function( response) {
            resolve(response);
        })
    });
    return promise;
}